module.exports = __webpack_public_path__ + "assets/9c890a8ce03ff77c41977f1a0f3b65b7.mp3";